import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AngleRight, ExternalLink } from '@mehilainen/mds-icons';
import { Gray700, Gray800, Gray900, Primary500, } from '@mehilainen/mds-tokens/colors';
import { spacing } from '@mehilainen/mds-tokens/spacing';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { Box, Stack, styled } from '@mui/material';
const Container = styled(Box)({
    display: 'flex',
    paddingLeft: spacing[500].rem,
    paddingRight: spacing[500].rem,
});
const RowContainer = styled(Stack)({
    flexDirection: 'row',
    gap: spacing[500].rem,
    width: '100%',
});
const IconContainer = styled(Box)({
    display: 'flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    height: 'min(138px, 100%)',
});
const StartIconContainer = styled(IconContainer)({
    color: Primary500,
    fontSize: baseTypography.size.icon[400].px,
});
const ContentRowContainer = styled(Stack)({
    flexDirection: 'row',
    width: '100%',
});
const ContentContainer = styled(Stack)({
    flex: 1,
    paddingTop: spacing[600].rem,
    paddingBottom: spacing[600].rem,
    gap: spacing[400].rem,
    alignItems: 'flex-start',
});
const MainContentContainer = styled(Stack)({
    gap: spacing[200].rem,
});
const Title = styled(Stack)({
    flexDirection: 'row',
    gap: spacing[300].rem,
    color: Gray900,
    fontSize: baseTypography.size[400].rem,
    fontWeight: baseTypography.weight.Medium,
    lineHeight: baseTypography.height.Medium,
});
const SecondaryText = styled(Title)({
    fontSize: baseTypography.size[300].rem,
    fontWeight: baseTypography.weight.Regular,
    lineHeight: baseTypography.height.Medium,
});
const TopLabel = styled(SecondaryText)({
    color: Primary500,
});
const Description = styled(SecondaryText)({
    color: Gray800,
});
const AdditionalInfoContainer = styled(Stack)({
    alignItems: 'flex-start',
    textAlign: 'left',
    fontSize: baseTypography.size[300].rem,
    fontWeight: baseTypography.weight.Regular,
    lineHeight: baseTypography.height.Medium,
    color: Gray700,
});
export const eventContentClasses = {
    root: 'MdsEventContent-root',
    contentRow: 'MdsEventContent-contentRow',
};
/**
 * EventContent component
 *
 * Shows various health-related tasks
 * @param actionIndicator - Action indicator
 * @param additionalInfo - Additional info
 * @param additionalInfoChip - Additional info chip
 * @param description - Description text
 * @param endIcon - Icon component used at the right side of the event
 * @param eventType - Event type
 * @param startIcon - Icon component used at the left side of the event
 * @param sx - Custom styles using MUI's sx prop
 * @param title - Title text
 * @param topLabel - Top label text
 * @returns EventContent component
 */
export const EventContent = ({ actionIndicator, additionalInfo, additionalInfoChip, description, endIcon = 'AngleRight', eventType, startIcon, sx, title, topLabel, }) => {
    const iconSx = {
        fontSize: baseTypography.size.icon[500].px,
        color: Gray700,
    };
    return (_jsx(Container, { sx: sx, className: eventContentClasses.root, children: _jsxs(RowContainer, { children: [startIcon && (_jsx(StartIconContainer, { "aria-hidden": "true", children: startIcon })), _jsxs(ContentRowContainer, { className: eventContentClasses.contentRow, children: [_jsxs(ContentContainer, { children: [_jsxs(MainContentContainer, { children: [topLabel && _jsx(TopLabel, { children: topLabel }), _jsx(Title, { children: title }), description && _jsx(Description, { children: description }), eventType && _jsx(Description, { children: eventType }), additionalInfo && (_jsx(AdditionalInfoContainer, { children: additionalInfo }))] }), additionalInfoChip, actionIndicator] }), _jsx(IconContainer, { children: endIcon === 'ExternalLink' ? (_jsx(ExternalLink, { "aria-hidden": "true", sx: iconSx })) : (_jsx(AngleRight, { "aria-hidden": "true", sx: iconSx })) })] })] }) }));
};
